import DashboardLayout from '../layouts/DashboardLayout'
// import OrderList from '../pages/order/OrderList'
// import OrderDetail from '../pages/order/OrderDetail'
// import OrderListMobile from '../pages/order/OrderListMobile'
// import OrderCreateContact from '../pages/order/OrderCreateContact'
// import OrderAccountList from '../pages/order/OrderAccountList'
// import OrderAccountListMobile from "@/pages/order/OrderAccountListMobile";

export const orderMenu = {
  path: '/orders',
  component: DashboardLayout,
  name: 'Orders',
  redirect: '/orders',
  children: [
    {
      path: 'order-list',
      name: 'OrderList',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/OrderList.vue'),
      meta: {
        roles: ['order_read','order_create','order_update','order_delete', 'order_view_all', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách đơn hàng',
        }],
        title: 'CRM Order List',
      },
    },
    {
      path: 'receipt-list',
      name: 'ReceiptList',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/ReceiptList.vue'),
      meta: {
        roles: ['order_read','order_create','order_update','order_delete', 'order_view_all', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách phiếu thu',
        }],
        title: 'CRM Receipt List',
      },
    },
    {
      path: '/order-detail/:id',
      name: 'OrderDetail',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/OrderDetail.vue'),
      meta: {
        roles: ['order_update', 'order_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách đơn hàng',
          to: '/orders/order-list'
        },{
          title: 'Thông tin đơn hàng',
        }]
      },
    },
    {
      path: 'order-payment-checklist',
      name: 'orderPaymentChecklist',
      component: () => import (/* webpackChunkName: "about" */'../pages/order-payment-checklist/List.vue'),
      meta: {
        roles: ['reconcile-sms_read', 'reconcile-sms_view_all'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Đối soát SMS',
        }]
      },
    },
    {
      path: '/mobile/orders/order-list',
      name: 'OrderListMobile',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/OrderListMobile.vue'),
      meta: {
        roles: ['order_read','order_create','order_update','order_delete', 'order_view_all', 'search_all_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách đơn hàng',
        }]
      }
    },
    {
      path: 'order-create',
      name: 'OrderCreateContact',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/OrderCreateContact.vue'),
      meta: {
        roles: ['order-ctv-create_read'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: 'update-contact-info',
      name: 'UpdateContactInfoNoId',
      component: () => import(/* webpackChunkName: "about" */'../pages/order/create-order-new/UpdateContactInfo.vue'),
      meta: {
        roles: ['order_create'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
        {
      path: '/order-detail-new/:id/',
      name: 'OrderDetailNew',
      component: () => import(/* webpackChunkName: "about" */'../pages/order/create-order-new/CreateOrder.vue'),
      meta: {
        roles: ['order_create'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: ':id/account',
      name: 'OrderAccountList',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/OrderAccountList.vue'),
      meta: {
        roles: ['order-contact_read'],
        requiresAuth: true,
        breadcrumb: []
      },
    },
    {
      path: '/mobile/orders/:id/account',
      name: 'OrderAccountListMobile',
      component: () => import (/* webpackChunkName: "about" */'../pages/order/OrderAccountListMobile.vue'),
      meta: {
        roles: ['order-contact_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách tài khoản',
        }]
      }
    },
  ],
}
